module.exports = __webpack_public_path__ + "static/media/randomize.d578b6de.png";